import { FC, useState } from 'react';

import { GridColumn } from '@hh.ru/magritte-ui-grid/Column';
import { GridLayout } from '@hh.ru/magritte-ui-grid/Layout';
import { GridRow } from '@hh.ru/magritte-ui-grid/Row';

import styles from './highlighter.less';

interface GridHighlighterProps {
    /** Включает показ подсветки модульной сетки */
    show?: boolean;
}

export const GridHighlighter: FC<GridHighlighterProps> = ({ show = false }) => {
    const [isVisibleLeftSidebar, setVisibleLeftSidebar] = useState(false);
    const [isVisibleRightSidebar, setVisibleRightSidebar] = useState(false);

    const [isVisibleLeftSidebarOnXL, setVisibleLeftSidebarOnXL] = useState(false);
    const [isVisibleRightSidebarOnXL, setVisibleRightSidebarOnXL] = useState(false);

    const [isVisibleSettings, setVisibleSettings] = useState(false);

    if (!show) {
        return null;
    }

    const content = <div className={styles['grid-highlighter-column']} />;

    return (
        <div className={styles['grid-highlighter-wrapper']}>
            <GridLayout
                rightSidebar={isVisibleRightSidebar ? content : undefined}
                leftSidebar={isVisibleLeftSidebar ? content : undefined}
                hideLeftOnXL={isVisibleLeftSidebarOnXL}
                hideRightOnXL={isVisibleRightSidebarOnXL}
            >
                <GridRow>
                    <GridColumn xs={1}>{content}</GridColumn>
                    <GridColumn xs={1}>{content}</GridColumn>
                    <GridColumn xs={1}>{content}</GridColumn>
                    <GridColumn xs={1}>{content}</GridColumn>
                    <GridColumn xs={0} s={1}>
                        {content}
                    </GridColumn>
                    <GridColumn xs={0} s={1}>
                        {content}
                    </GridColumn>
                    <GridColumn xs={0} s={1}>
                        {content}
                    </GridColumn>
                    <GridColumn xs={0} s={1}>
                        {content}
                    </GridColumn>
                    <GridColumn xs={0} m={1}>
                        {content}
                    </GridColumn>
                    <GridColumn xs={0} m={1}>
                        {content}
                    </GridColumn>
                    <GridColumn xs={0} m={1}>
                        {content}
                    </GridColumn>
                    <GridColumn xs={0} m={1}>
                        {content}
                    </GridColumn>
                </GridRow>
            </GridLayout>
            {isVisibleSettings && (
                <div className={styles['grid-highlighter-grid-props']} data-qa="magritte-highlighter-settings">
                    <div className={styles['grid-highlighter-grid-prop']}>
                        <div>Left sidebar: {isVisibleLeftSidebar ? 'on' : 'off'}</div>
                        <button
                            type="button"
                            className={styles.gridHighlighterToggle}
                            onClick={() => setVisibleLeftSidebar(!isVisibleLeftSidebar)}
                        >
                            toggle
                        </button>
                    </div>
                    <div className={styles['grid-highlighter-grid-prop']}>
                        <div>Right sidebar: {isVisibleRightSidebar ? 'on' : 'off'}</div>
                        <button
                            type="button"
                            className={styles.gridHighlighterToggle}
                            onClick={() => setVisibleRightSidebar(!isVisibleRightSidebar)}
                        >
                            toggle
                        </button>
                    </div>
                    <div className={styles['grid-highlighter-grid-prop']}>
                        <div>Hide left sidebar on XL: {isVisibleLeftSidebarOnXL ? 'on' : 'off'}</div>
                        <button
                            type="button"
                            className={styles.gridHighlighterToggle}
                            onClick={() => setVisibleLeftSidebarOnXL(!isVisibleLeftSidebarOnXL)}
                        >
                            toggle
                        </button>
                    </div>
                    <div className={styles['grid-highlighter-grid-prop']}>
                        <div>Hide right sidebar on XL: {isVisibleRightSidebarOnXL ? 'on' : 'off'}</div>
                        <button
                            type="button"
                            className={styles.gridHighlighterToggle}
                            onClick={() => setVisibleRightSidebarOnXL(!isVisibleRightSidebarOnXL)}
                        >
                            toggle
                        </button>
                    </div>
                </div>
            )}
            <button
                type="button"
                data-qa="magritte-highlighter-toggle-settings"
                className={styles['grid-highlighter-settings']}
                onClick={() => setVisibleSettings(!isVisibleSettings)}
            >
                ⚙️
            </button>
        </div>
    );
};

GridHighlighter.displayName = 'GridHighlighter';
